import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ProductDashboardLastReceivedModel } from "src/app/core/models/product-model/product-dashboard-model/product-dashboard-lastreceived.model";
import { PRODUCT_DASHBOARD_SPECIALSERVICE_LASTRECEIVED_DEMO } from "./product-dashboard-specialservice-lastreceived-demo-data";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-specialservice-lastreceived.component.html',
    selector: 'op-product-dashboard-specialservice-lastreceived'
})
export class ProductDashboardSpecialServiceLastReceivedComponent implements AfterViewInit {
    public lastReceivedInfo: ProductDashboardLastReceivedModel[];
    
    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.lastReceivedInfo = PRODUCT_DASHBOARD_SPECIALSERVICE_LASTRECEIVED_DEMO;
            this.changeDetection.detectChanges();
        }, 500);
    }
}